import React from 'react';

const SortableHeader = ({ column, children, onSort, getSortIcon, ...props }) => {
    const isActive = getSortIcon(column) !== '⇅';
    
    return (
        <th 
            style={{ 
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'all 0.2s ease',
                position: 'relative',
                backgroundColor: isActive ? '#e3f2fd' : 'transparent',
                borderBottom: isActive ? '2px solid #2196f3' : '1px solid #dee2e6'
            }} 
            className="sortable-header"
            onClick={() => onSort(column)}
            onMouseEnter={(e) => {
                if (!isActive) e.target.style.backgroundColor = '#f5f5f5';
            }}
            onMouseLeave={(e) => {
                if (!isActive) e.target.style.backgroundColor = 'transparent';
            }}
            {...props}
        >
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                fontWeight: isActive ? 'bold' : '600'
            }}>
                <span>{children}</span>
                <span style={{ 
                    fontSize: '12px',
                    color: isActive ? '#2196f3' : '#9e9e9e',
                    marginLeft: '8px',
                    opacity: isActive ? 1 : 0.6,
                    transform: `scale(${isActive ? 1.1 : 1})`,
                    transition: 'all 0.2s ease'
                }}>
                    {getSortIcon(column)}
                </span>
            </div>
        </th>
    );
};

export default SortableHeader;